$(function () {

    var LMS_ONE_APP_ID = 8;

    var subscriptionData = {
        isTrial: false,
        companyId: 0,
        totalUsers: 1,
        totalMobileUsers: 0,
        totalGB: 1,
        totalSMS: 0,
        pricePerUser: 0.00,
        userPriceCap: null,
        pricePerMobileUser: 0.00,
        mobileUserPriceCap: null,
        pricePerGB: 0.0,
        pricePerSMS: 0.00,
        selectedApps: [5],
        activePersonnel: 0,
        priceApps: [
            {
                id: 5,
                name: "Stems",
                price: 0.00
            }, {
                id: 7,
                name: "Comply One",
                price: 0.00
            }, {
                id: LMS_ONE_APP_ID,
                name: "LMS One",
                price: 0.00
            }],
        personnelPricingBlocks:[],
        voucher: null,
        billingDate: null
    };

    var _updateUserValues = function () {
        var total = parseInt($("[data-subs-slider=users]").slider("getValue"));

        $("[data-subs=users_label]").html(total.toString());
        subscriptionData.totalUsers = total;
    }

    var _updateMobileUserValues = function () {
        var total = parseInt($("[data-subs-slider='mobile-only-users']").slider("getValue"));
        $("[data-subs=mobile_users_label]").html(total.toString());
        subscriptionData.totalMobileUsers = total;
    }

    var _updateStorageValues = function () { 
        var total = 0.00;

        if ($("[data-subs-slider=storage]").length > 0) {
            total = parseInt($("[data-subs-slider=storage]").slider("getValue"));
        }
        else if ($("[data-subs=storage_total]").length > 0) {
            total = parseFloat($("[data-subs=storage_total]").html());
        }

        $("[data-subs=storage_label]").html(total.toString());
        subscriptionData.totalGB = total;
    }

    var _updateSMSValues = function () {
        var total = 0;

        if ($("[data-subs-slider=sms]").length > 0) {
            total = parseInt($("[data-subs-slider=sms]").slider("getValue"));
        }
        else if ($("[data-subs=sms_total]").length > 0) {
            total = parseInt($("[data-subs=sms_total]").html());
        }

        $("[data-subs=sms_label]").html(total.toString());
        subscriptionData.totalSMS = total;
    }

    var _updateSelectedApps = function () {
        $(".widget-switch").each(function (idx, element) {

            if ($(element).switchIsOn()) {
                var appId = parseInt($(element).switchVal());
                subscriptionData.selectedApps.push(appId);
            }

        });

    };

    var _updateActivePersonnel = function () {
        var total = 0;

        if ($("[data-subs-slider=personnel]").length > 0) {
            total = parseInt($("[data-subs-slider=personnel]").slider("getValue"));
        }
        else if ($("[data-subs=active_personnel]").length > 0) {
            total = parseInt($("[data-subs=active_personnel]").html());
        }

        $("[data-subs=personnel_label]").html(total.toString());
        subscriptionData.activePersonnel = total;
    };

    var _updateVoucherData = function () {
        var value = $("[data-subs=voucher_input]").val();

        if (value) {
            _searchVoucher(value);
        }
    };

    var _updateBillingDateData = function () {
        var value = $(".widget-calendar[data-subs=billing_date]").children("input[type=hidden][name=nextBillingDate]").val();

        if (value) {
            subscriptionData.billingDate = value;
        }
    };

    var _toggleError = function (show) {
        if (show === true) {
            $("[data-subs=error_container]").show("slow");
        }
        else {
            $("[data-subs=error_container]").hide("slow");
        }
    }

    /**
     * Initializes the component
     * */
    var _init = function (pricingData) {

        if (pricingData == null) {
            _toggleError(true);
            return;
        }

        //load current prices
        subscriptionData.pricePerUser = pricingData.PricePerUser;
        subscriptionData.userPriceCap = pricingData.UserPriceCap;
        subscriptionData.pricePerMobileUser = pricingData.PricePerMobileUser;
        subscriptionData.mobileUserPriceCap = pricingData.MobileUserPriceCap;
        subscriptionData.pricePerGB = pricingData.PricePerGB;
        subscriptionData.pricePerSMS = pricingData.PricePerSMS;

        subscriptionData.personnelPricingBlocks = [];
        subscriptionData.priceApps = [];

        for (var i = 0; i < pricingData.PersonnelBlocks.length; i++) {
            subscriptionData.personnelPricingBlocks.push({
                id: pricingData.PersonnelBlocks[i].Id,
                startsAt: pricingData.PersonnelBlocks[i].StartingBlock,
                endsAt: pricingData.PersonnelBlocks[i].EndingBlock,
                price: pricingData.PersonnelBlocks[i].BlockPrice
            });
        }

        for (var i = 0; i < pricingData.Apps.length; i++) {
            var appPrice = {
                id: pricingData.Apps[i].Id,
                name: pricingData.Apps[i].Name,
                price: pricingData.Apps[i].Price
            }

            subscriptionData.priceApps.push(appPrice);
        }

        var mode = parseInt($("[data-subs=calc_mode]").val());

        _updateUserValues();
        _updateMobileUserValues();
        _updateStorageValues();
        _updateSMSValues();
        _updateActivePersonnel();
        _updateSelectedApps();
        _updateVoucherData();
        _updateBillingDateData();

        //if (mode == 0) {
        //    _updateSMSValues();
        //    $("[data-subs=price_sms_row]").removeClass("hidden");
        //}
        //else {
        //    $("[data-subs=price_sms_row]").remove();
        //}

        _calculate();
    }

    /**
     * Fetches the current pricing list
     * */
    var _getPricingJson = function () {
        $.ajax({
            url: "/pricing/list/?cid=" + subscriptionData.companyId,
            method: "GET",
            success: function (d) {
                _init(d);
            },
            error: function (x, s, e) {
                _toggleError(true);
            }
        })
    }

    /**
     * Displays or hides an error message in the voucher section
     */
    var _toggleVoucherError = function (error, show) {
        if (show) {
            $(".calc-metric .alert").html(error);
            $(".calc-metric .alert").show();
        }
        else {
            $(".calc-metric .alert").html(" ");
            $(".calc-metric .alert").hide();
        }
    };

    /**
     * Generates the form fields to post to the server
     * */
    var _generateFormFields = function () {
        var $formFields = $("[data-subs=form_fields]");
        $formFields.html(null);

        var $maxUsers = $("<input type='hidden' name='maxUsers' />")
            .val(subscriptionData.totalUsers);
        $formFields.append($maxUsers);

        var $pricePerUser = $("<input type='hidden' name='pricePerUser' />")
            .val(subscriptionData.pricePerUser);
        $formFields.append($pricePerUser);

        var $maxMobileUsers = $("<input type='hidden' name='maxMobileUsers' />")
            .val(subscriptionData.totalMobileUsers);
        $formFields.append($maxMobileUsers);

        var $pricePerMobileUser = $("<input type='hidden' name='pricePerMobileUser' />")
            .val(subscriptionData.pricePerMobileUser);
        $formFields.append($pricePerMobileUser);

        var $companyId = $("<input type='hidden' name='companyId' />")
            .val(subscriptionData.companyId);
        $formFields.append($companyId);

        var $billingDate = $("<input type='hidden' name='nextBillingDate' />")
            .val(subscriptionData.billingDate);
        $formFields.append($billingDate);

        if (subscriptionData.voucher) {
            var $voucherId = $("<input type='hidden' name='voucherId' />")
                .val(subscriptionData.voucher.id);
            var $voucherNo = $("<input type='hidden' name='voucherNumber' />")
                .val(subscriptionData.voucher.number);

            $formFields.append($voucherId);
            $formFields.append($voucherNo);
        }

        for (var i = 0; i < subscriptionData.selectedApps.length; i++) {
            var appId = subscriptionData.selectedApps[i];
            var $appId = $("<input type='hidden' value='" + appId
                + "' name='selectedApplications[" + i + "].applicationId' />");

            var pa = subscriptionData.priceApps.filter(function (item) {
                return item.id == appId;
            });

            var $price = $("<input type='hidden' value='" + pa[0].price
                + "' name='selectedApplications[" + i + "].price' />");

            $formFields.append($appId);
            $formFields.append($price);
        }

        var hasLMS = subscriptionData.selectedApps.filter(function (a) {
            return a === LMS_ONE_APP_ID;
        }).length > 0;

        if (hasLMS) {
            var $personnelCount = $("<input type='hidden' name='personnelCount' />")
                .val(subscriptionData.activePersonnel);
            $formFields.append($personnelCount);
        }
    }

    /**
     * Calculates prices and sets page elements
     */
    var _calculate = function () {
        var data = subscriptionData;
        var numbOfUsers = data.totalUsers;
        var numbOfMobileUsers = data.totalMobileUsers;
        var personnelBlocks = data.personnelPricingBlocks;
        var personnelCount = data.activePersonnel;
        var activePersonnelFee = 0.0;

        if (data.userPriceCap != null && data.totalUsers > data.userPriceCap)
            numbOfUsers = data.userPriceCap;

        if (data.mobileUserPriceCap != null && data.totalMobileUsers > data.mobileUserPriceCap)
            numbOfMobileUsers = data.mobileUserPriceCap;

        var subTotalUsers = data.pricePerUser * numbOfUsers;
        var subTotalMobileUsers = data.pricePerMobileUser * numbOfMobileUsers;
        var subTotalStorage = data.pricePerGB * (Math.ceil(data.totalGB) <= 1 ? 0 : (Math.ceil(data.totalGB) - 1));
        var subTotalSMS = data.pricePerSMS * data.totalSMS;
        var selectedAppPrices = [];
        var subTotal = subTotalUsers + subTotalMobileUsers + subTotalStorage + subTotalSMS;

        var subTotalUsersFormatted = subTotalUsers.currency();
        $("[data-subs=users_price]").html(subTotalUsersFormatted);
        $("[data-subs=users_price_summary]").html(subTotalUsersFormatted);

        var subTotalMobileUsersFormatted = subTotalMobileUsers.currency();
        $("[data-subs=mobile_users_price]").html(subTotalMobileUsersFormatted);
        $("[data-subs=mobile_users_price_summary]").html(subTotalMobileUsersFormatted);

        var subTotalStorageFormatted = subTotalStorage.currency();
        $("[data-subs=storage_price]").html(subTotalStorageFormatted);
        $("[data-subs=storage_price_summary]").html(subTotalStorageFormatted);

        var subTotalSMSFormatted = subTotalSMS.currency();
        $("[data-subs=sms_price]").html(subTotalSMSFormatted);
        $("[data-subs=sms_price_summary]").html(subTotalSMSFormatted);

        //remove all price summary items related to apps
        $("table.price-items tr[data-subs=app_summary][data-app-id]").remove();

        //find selected app prices
        for (var i = 0; i < data.selectedApps.length; i++) {
            var appPrice = data.priceApps.filter(function (item) {
                return item.id == data.selectedApps[i];
            });

            if (appPrice.length === 1) {
                selectedAppPrices.push(appPrice[0]);
            }
        }

        //find app totals, add them to subtotal and add a row to the price summary
        for (var i = 0; i < selectedAppPrices.length; i++) {
            subTotal += selectedAppPrices[i].price;

            $("<tr data-subs='app_summary' data-app-id='" + selectedAppPrices[i].id
                + "'><td class='ta-r'><span>" + selectedAppPrices[i].name
                + "</span></td><td class='item-sep'><div></div></td>"
                + "<td class='ta-r'><span>" + selectedAppPrices[i].price.currency()
            + "</span></td></tr>").insertBefore("[data-subs=price_voucher_row]");
        }

        var lms = selectedAppPrices.filter(function (p) {
            return p.id === LMS_ONE_APP_ID;
        });

        if (lms.length > 0) {
            for (var i = 0; i < personnelBlocks.length; i++) {
                if (!personnelBlocks[i].endsAt && personnelBlocks[i].startsAt <= personnelCount) {
                    activePersonnelFee = personnelBlocks[i].price;
                    break;
                }

                if (personnelBlocks[i].startsAt <= personnelCount
                    && personnelBlocks[i].endsAt >= personnelCount) {
                    activePersonnelFee = personnelBlocks[i].price;
                    break;
                }
            }

            $("[data-subs=personnel_price]").html(activePersonnelFee.currency());
            $("[data-subs=personnel_price_summary]").html(activePersonnelFee.currency());
            $("[data-subs=price_personnel_row]").show();
            subTotal += activePersonnelFee;
        }
        else {
            activePersonnelFee = 0.0;
            $("[data-subs=price_personnel_row]").hide();
            $("[data-subs=personnel_price]").html(activePersonnelFee.currency());
        }


        var total = subTotal;

        if (subscriptionData.voucher) {
            var voucherDiscount = 0;

            if (subscriptionData.voucher.discountType == "Fixed") {
                voucherDiscount = subscriptionData.voucher.amount;
            }
            else if (subscriptionData.voucher.discountType == "Percent") {
                voucherDiscount = (subscriptionData.voucher.amount / 100) * total;
            }

            if (voucherDiscount > 0) {

                //guard from a discount greater than total
                if (voucherDiscount > total) {
                    voucherDiscount = total;
                }

                total = total - voucherDiscount;

                $("[data-subs=price_voucher_row]")
                    .find("[data-subs=voucher_discount_amount]").html((0 - voucherDiscount).currency());
                $("[data-subs=price_voucher_row]").show();
            }
        }

        if (subscriptionData.isTrial) total = 0;
        $("[data-subs=price_total]").html(total.currency());
        _generateFormFields();
    };

    /**
     * Stops the loading animation of a button
     */
    var _toggleLoadingButton = function ($btn, iconClass, shouldDisable) {
        setTimeout(function () {
            $btn.removeClass("btn-loading")
                .children("span")
                .removeClass(function (idx, className) {
                    return (className.match(/(^|\s)glyphicon\S+/g) || []).join(' ');
                })
                .removeClass(function (idx, className) {
                    return (className.match(/(^|\s)fa\S+/g) || []).join(' ');
                });

            if (iconClass) {
                $btn.children("span").first().addClass(iconClass);
            }

            if (shouldDisable) {
                $btn.removeProp("disabled");
            }

        }, 300);
    };

    /**
     * Searches for a voucher and applies it to the subscription
     */
    var _searchVoucher = function (number) {
        _toggleVoucherError(null, false);

        $.ajax({
            url: "/vouchers/check/" + encodeURIComponent(number) + "/?cid=" + subscriptionData.companyId,
            method: "GET",
            success: function (d) {

                if (!d) {
                    _toggleVoucherError("Unknown error", true);
                    return;
                }

                if (d.success) {
                    $("[data-subs=voucher_input]").val("");

                    if (d.voucher) {
                        subscriptionData.voucher = d.voucher;
                        $("[data-subs=voucher_id]").val(d.voucher.id);
                        $("[data-subs=voucher_no]").html(d.voucher.number);
                        $("[data-subs=voucher_discount]").html(d.voucher.discount);

                        if (d.voucher.expiry != null) {
                            $("[data-subs=voucher_expiry]").attr("stems-date", d.voucher.expiry);
                        }
                        else {
                            $("[data-subs=voucher_expiry]").removeAttr("stems-date").html("Never Expires")
                        }

                        $("[data-subs=voucher_input_group]").hide();
                        $("[data-subs=voucher_details]").show();

                        _calculate();
                    }

                    _toggleLoadingButton($("[data-subs=add_voucher]"), "fas fa-plus");
                }
                else {
                    _toggleLoadingButton($("[data-subs=add_voucher]"), "fas fa-plus");
                    _toggleVoucherError(d.error ? d.error : "Unknown error", true);
                }
            },
            error: function (x, s, e) {
                _toggleLoadingButton($("[data-subs=add_voucher]"), "fas fa-plus");
                _toggleVoucherError(e, true);
            }
        });
    };

    /**
     * Removes a voucher from the current subscription
     */
    var _removeVoucher = function () {
        subscriptionData.voucher = null;

        $("[data-subs=voucher_input_group]").show();
        $("[data-subs=voucher_details]").hide();

        $("[data-subs=voucher_id]").val("");
        $("[data-subs=voucher_number]").html(" ");
        $("[data-subs=voucher_discount]").html(" ");
        $("[data-subs=price_voucher_row]").hide();

        _calculate();
    };

    //setup sliders
    $("[data-subs-slider]").each(function (idx, element) {
        var min = $(this).data("min");
        var max = $(this).data("max");
        var value = $(this).data("value");
        var disabled = $(this).data("disabled");

        $(this).slider({
            min: min,
            max: max,
            value: value,
            enabled: !disabled,
            tooltip: "hide"
        });
    });

    $(".price-summary").on("affix.bs.affix", function () {
        var w = $(this).width();
        $(this).width(w);
    });

    //handles the slide event on the slider
    $("[data-subs-slider]").on("change", function () {
        var type = $(this).data("subs-slider");
        
        if (type == "users") {
            _updateUserValues();
        }
        else if (type == "mobile-only-users") {
            _updateMobileUserValues();
        }
        else if (type == "personnel") {
            _updateActivePersonnel();
        }
        else if (type == "storage") {
            _updateStorageValues();
        }
        else if (type == "sms") {
            _updateSMSValues();
        }

        _calculate();
    }); 

    //handles clicking on "Purchase"
    $("[data-subs=go]").click(function () {
        console.log(subscriptionData);
    });

    //handles the switch changed on individual applications
    $(".pricing-apps .widget-switch").on(WidgetEvents.STEMS_ON_CHANGE, function () {
        var checked = $(this).val();
        var value = $(this).find("input").val();

        if (checked) {
            $(this).parents(".app-list li").addClass("selected");
            subscriptionData.selectedApps.push(parseInt(value));
        }
        else {
            $(this).parents(".app-list li").removeClass("selected");
            var newApps = subscriptionData.selectedApps.filter(function (item) {
                return item != parseInt(value);
            });

            subscriptionData.selectedApps = newApps;
        }

        _calculate();
    });

    //handles voucher inputs
    $("[data-subs=voucher_input]").on("keyup paste", function () {

        var _self = this;
        setTimeout(function () {
            var value = $(_self).val();

            if (value) {
                $("[data-subs=add_voucher]").removeProp("disabled");
            }
            else {
                $("[data-subs=add_voucher]").prop("disabled", "disabled");
            }
        }, 50);
        
    });

    //handles clicking on "Add Voucher"
    $("[data-subs=add_voucher]").on("click", function () {
        var number = $("[data-subs=voucher_input]").val();

        _searchVoucher(number);
    });

    //handles clicking on "Remove Voucher"
    $("[data-subs=remove_voucher]").on("click", function () {
        _removeVoucher();
    });

    $(".widget-calendar[data-subs=billing_date]")
        .on(WidgetEvents.CALENDAR_CHANGED, function () {
            var value = $(this).find("input[type=hidden]").val();
            subscriptionData.billingDate = value;
            _calculate();
        });

    $("[data-subs=error_close]").click(function () {
        _toggleError(false);
    })


    //runs initialization code
    $("[data-subs=pricing_calculator]").each(function (idx, element) {
        var companyId = $(element).find("[data-subs=subs_company_id]").val();
        var isTrial = $(element).find("[data-subs=subs_is_trial]").val();

        subscriptionData.companyId = companyId;
        subscriptionData.isTrial = isTrial == "true";

        _getPricingJson();

        var offsetTop = $(".price-summary").offset().top;
        $(".price-summary").affix({
            offset: {
                top: offsetTop - 60
            }
        });
    });
});